const styles = {
  pending: "bg-slate-100 text-slate-700 border-slate-200",
  qualified: "bg-blue-50 text-[#002FA7] border-blue-200",
  rejected: "bg-amber-50 text-amber-800 border-amber-200",
  invalid: "bg-red-50 text-red-700 border-red-200",
  sent: "bg-green-50 text-green-700 border-green-200",
  replied: "bg-emerald-100 text-emerald-800 border-emerald-300",
};

export default function StatusBadge({ status }) {
  const s = (status || "pending").toLowerCase();
  const cls = styles[s] || styles.pending;
  return (
    <span
      data-testid={`status-${s}`}
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[11px] font-semibold border ${cls}`}
    >
      <span
        className="h-1.5 w-1.5 rounded-full"
        style={{ backgroundColor: "currentColor" }}
      />
      {s}
    </span>
  );
}
